module.exports = __webpack_public_path__ + "static/media/ic-transport.5007443a.svg";